import React from 'react';

// Styles & Assets
import styles from './SelectorZonesBed.module.css';

// Components
import SelectableButton from '../../UI/SelectableButton/SelectableButton';

// Interfaces
import { Bed } from '../../../interfaces/Patient';
import { ITown } from '../../../interfaces/Patient';

interface Props<T extends { id: string }> {
    itemsToBlock?: T['id'][]
    selectedItemsIDs: T['id'][]
    items: T[]
    classButton?: string
    handleSelect: (item: T) => void,
}

const SelectorZonesBed = <T extends Bed | ITown,>({ itemsToBlock, classButton, selectedItemsIDs, items, handleSelect }: Props<T>) => {

    const getNonClickable = (item: T) => {
        if (itemsToBlock) return itemsToBlock?.some(id => id === item.id);
        return false;
    };

    return (
        <div className={styles.itemsContainer}>
            {items.map(item =>
                <SelectableButton key={item.id}
                    label={item?.name || ''}
                    disabled={getNonClickable(item)}
                    active={selectedItemsIDs.some(id => id === item.id)}
                    handleClick={() => handleSelect(item)}
                    classButton={classButton}
                />
            )}
        </div>
    );
};

export default SelectorZonesBed;